import { genComponentStyleHook, type FullToken } from './styleUtil'
import { getAnimationBackground, getBackgroundAnimation, getBorderStyle } from './gradientUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Button', 'techTheme'], (token: FullToken) => {
  const { componentCls, lineWidth } = token
  const backgroundAnimation = getBackgroundAnimation(lineWidth)

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`&${componentCls}-primary`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          ...getAnimationBackground(lineWidth),
          ...backgroundAnimation,
          '&:disabled': {
            opacity: token.opacityLoading,
            color: token.colorTextLightSolid,
          },
        },
      },
      [`&${componentCls}-default`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          '&:before': getBorderStyle(lineWidth),
          '&:not(:disabled):hover': {
            color: token.colorTextLightSolid,
          },
          '&:disabled:before': {
            opacity: token.opacityLoading,
          },
        },
      },
      [`&${componentCls}-primary, &${componentCls}-default`]: {
        [`&:not(:disabled):not(${componentCls}-dangerous)`]: {
          '&:hover': { filter: 'brightness(120%)' },
          '&:active': { filter: 'brightness(80%)' },
        },
      },
    },
  }
})
